import { render, staticRenderFns } from "./info-individual.vue?vue&type=template&id=72d6dec0&"
import script from "./info-individual.vue?vue&type=script&lang=js&"
export * from "./info-individual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports